"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartPricingEdit = void 0;
const merlin_info_panels_1 = require("@travelnest/merlin.info-panels");
const merlin_input_stepper_1 = require("@travelnest/merlin.input-stepper");
const React = __importStar(require("react"));
const Chip_1 = require("../../../components/chip/Chip");
const HorizontalRule_1 = require("../../../components/horizontal-rule/HorizontalRule");
const Label_1 = require("../../../components/input/label/Label");
const Spacer_1 = require("../../../components/spacer/Spacer");
const theme_1 = __importDefault(require("../../../components/styles/theme"));
const ContentPage_1 = require("../../base/ContentPage");
const TaskPage_1 = require("../../base/TaskPage");
const styled_1 = __importDefault(require("@emotion/styled"));
const IconTextSpan_1 = require("../../../components/icon-text-span/IconTextSpan");
const MarginWrapper_1 = require("../../../components/margin/MarginWrapper");
const Heading_1 = require("../../../components/heading/Heading");
const FormInputCurrency_1 = require("../../../components/input/form-input/FormInputCurrency");
const price_graph_gbp_svg_1 = __importDefault(require("../../../components/smart-pricing-modals/opt-in/price-graph_gbp.svg"));
const price_graph_usd_svg_1 = __importDefault(require("../../../components/smart-pricing-modals/opt-in/price-graph_usd.svg"));
const price_graph_eur_svg_1 = __importDefault(require("../../../components/smart-pricing-modals/opt-in/price-graph_eur.svg"));
const helpers_1 = require("../../../../entities/pricing/helpers");
const InlineMessage_1 = require("../../../../view/components/inline-message/InlineMessage");
const validation_1 = require("./validation");
const types_1 = require("../../../../types");
const helpers_2 = require("./helpers");
const completionProps = (valid) => (valid ?
    { text: 'This section is complete', display: 'success', icon: 'check' } :
    { text: 'This section is incomplete', display: 'error', icon: 'exclamation', errorTextColour: true });
const StyledIconTextSpan = (0, styled_1.default)(IconTextSpan_1.IconTextSpan) `
.icon-text-span_text {
	color: ${theme_1.default.colours.text.darker};
}
`;
const getCurrencyBasedSvg = (currency) => {
    switch (currency) {
        case 'GBP':
            return price_graph_gbp_svg_1.default;
        case 'EUR':
            return price_graph_eur_svg_1.default;
        case 'USD':
            return price_graph_usd_svg_1.default;
        default:
            return price_graph_gbp_svg_1.default;
    }
};
const patchDefaultsFactory = (pricingDefaults, changeFn) => (p) => changeFn(Object.assign(Object.assign({}, pricingDefaults), p));
const SmartPricingEdit = (props) => {
    var _a, _b, _c;
    const { pricingDefaults, onChange } = props;
    const patchDefaults = patchDefaultsFactory(pricingDefaults, onChange);
    const onBackButtonTap = (e) => {
        e.preventDefault();
        props.onExit();
    };
    const [validation, setValidation] = React.useState((0, validation_1.validatePricingDefaults)(pricingDefaults));
    const allValid = Object.values(validation).every((v) => v);
    const completion = completionProps(allValid);
    const [showValidation, setShowValidation] = React.useState(!allValid);
    React.useEffect(() => {
        setValidation((0, validation_1.validatePricingDefaults)(pricingDefaults));
    }, [pricingDefaults]);
    const minimumPriceValueChangeHandler = (e) => {
        setShowValidation(true);
        const numericOnlyValue = e.target.value.replace(/\D/g, '');
        const inputNum = parseInt(numericOnlyValue, 10);
        let propagateVal;
        if (numericOnlyValue === '') {
            propagateVal = 0;
        }
        else {
            if (isNaN(inputNum)) {
                return;
            }
            propagateVal = inputNum;
        }
        // Transform to internal storage format.
        patchDefaults({ min_price: (0, helpers_2.toFloyd)(propagateVal) });
    };
    const sevenNightDiscount = pricingDefaults.discounts.find((d) => d.nights === 7);
    const sevenNightDiscountAmount = (0, helpers_1.factorDiscountToPercentage)((_a = sevenNightDiscount === null || sevenNightDiscount === void 0 ? void 0 : sevenNightDiscount.factor) !== null && _a !== void 0 ? _a : helpers_1.NO_DISCOUNT_FACTOR);
    const twentyEightNightDiscount = pricingDefaults.discounts.find((d) => d.nights === 28);
    const twentyEightNightDiscountAmount = (0, helpers_1.factorDiscountToPercentage)((_b = twentyEightNightDiscount === null || twentyEightNightDiscount === void 0 ? void 0 : twentyEightNightDiscount.factor) !== null && _b !== void 0 ? _b : helpers_1.NO_DISCOUNT_FACTOR);
    const updateDiscounts = (numNights, newDiscountAmount) => {
        const restOfDiscounts = pricingDefaults.discounts.filter((d) => d.nights !== numNights);
        patchDefaults(Object.assign(Object.assign({}, pricingDefaults), { discounts: [
                ...restOfDiscounts,
                { nights: numNights, factor: (0, helpers_1.percentageDiscountToFactor)(newDiscountAmount) }
            ] }));
    };
    return React.createElement(ContentPage_1.ContentPage, { title: "Smart pricing", backLinkClick: onBackButtonTap },
        React.createElement(MarginWrapper_1.MarginWrapper, null,
            React.createElement(Spacer_1.Spacer, { spacing: "large" }),
            React.createElement(StyledIconTextSpan, Object.assign({}, completion, { iconSize: "large" })),
            React.createElement(Spacer_1.Spacer, { spacing: "large" })),
        React.createElement(HorizontalRule_1.HorizontalRule, null),
        React.createElement(Spacer_1.Spacer, { spacing: "large" }),
        React.createElement(TaskPage_1.TaskLayout, { width: 50 },
            React.createElement(TaskPage_1.TaskColumn, null,
                React.createElement(MarginWrapper_1.MarginWrapper, null,
                    React.createElement(Heading_1.HeadingSmall, null, "Minimum Price"),
                    React.createElement(Spacer_1.Spacer, { spacing: "small" }),
                    React.createElement(FormInputCurrency_1.FormInputCurrency, { id: "minimum-price", currency: pricingDefaults.currency, 
                        // Present value as human readable
                        value: (0, helpers_2.fromFloyd)(pricingDefaults.min_price), onChange: minimumPriceValueChangeHandler, showValidationError: showValidation && !validation.min_price, 
                        // If not true
                        errorMessage: showValidation && ((_c = !(validation === null || validation === void 0 ? void 0 : validation.min_price)) !== null && _c !== void 0 ? _c : true) ? 'The minimum price per night must be greater than 0.' : '' }),
                    React.createElement(Spacer_1.Spacer, { spacing: "small" }),
                    React.createElement(merlin_info_panels_1.DidYouKnow, { id: "min-price-info-panel", icon: getCurrencyBasedSvg(pricingDefaults.currency), colour: { background: '#f7f7f7', text: '#666666' }, text: "Set a limit that your prices can never go below, even when demand is low." }),
                    React.createElement(HorizontalRule_1.HorizontalRule, null),
                    React.createElement(Spacer_1.Spacer, { spacing: "large" }),
                    React.createElement(Heading_1.HeadingSmall, null, "Arrival days"),
                    React.createElement(Spacer_1.Spacer, { spacing: "small" }),
                    React.createElement(Chip_1.ChipQuestion, { question: "Select which days guests can arrive" }, Object.entries(types_1.DaysOfWeekFullNames).map(([dow, fullName]) => (React.createElement(Chip_1.Chip, { id: dow, key: dow, text: fullName, selected: pricingDefaults.checkin_days.includes(dow), onChange: (_, selected) => {
                            setShowValidation(true);
                            const nextCheckinDays = [...pricingDefaults.checkin_days];
                            if (selected) {
                                nextCheckinDays.push(dow);
                            }
                            else {
                                nextCheckinDays.splice(nextCheckinDays.indexOf(dow), 1);
                            }
                            patchDefaults(Object.assign(Object.assign({}, pricingDefaults), { checkin_days: nextCheckinDays }));
                        } })))),
                    showValidation && !(validation === null || validation === void 0 ? void 0 : validation.checkin_days) &&
                        React.createElement(React.Fragment, null,
                            React.createElement(Spacer_1.Spacer, null),
                            React.createElement(InlineMessage_1.InlineError, { text: "Please select at least one day" })),
                    React.createElement(Spacer_1.Spacer, { spacing: "large" }),
                    React.createElement(HorizontalRule_1.HorizontalRule, null),
                    React.createElement(Spacer_1.Spacer, { spacing: "large" }),
                    React.createElement(Heading_1.HeadingSmall, null, "Minimum stay"),
                    React.createElement(Spacer_1.Spacer, null),
                    React.createElement(Label_1.ParagraphLabel, { htmlFor: "minimum-nights-stay" }, "Define the shortest duration a guest can stay"),
                    React.createElement(Spacer_1.Spacer, null),
                    React.createElement(merlin_input_stepper_1.InputStepper, { id: "minimum-nights-stay", onClick: (nightStay) => patchDefaults({ min_stay: nightStay }), minValue: 1, maxValue: 7, value: pricingDefaults.min_stay || 1, valueFormatter: (n) => `${n} night${n === 1 ? '' : 's'}` }),
                    React.createElement(Spacer_1.Spacer, null),
                    React.createElement(merlin_info_panels_1.DidYouKnow, { colour: 'purple', id: 'min-stay', text: "A minimum stay of 1 or 2 nights will increase your chances of getting booked" }),
                    React.createElement(HorizontalRule_1.HorizontalRule, null),
                    React.createElement(Spacer_1.Spacer, { spacing: "large" }),
                    React.createElement(Heading_1.HeadingSmall, null, "Discounts"),
                    React.createElement(Spacer_1.Spacer, { spacing: "large" }),
                    React.createElement(Label_1.ParagraphLabel, { htmlFor: "seven-night-discount" }, "7 night discount"),
                    React.createElement(Spacer_1.Spacer, { spacing: "smaller" }),
                    React.createElement(merlin_input_stepper_1.InputStepper, { id: "seven-night-discount", onClick: (next7ND) => updateDiscounts(7, next7ND), minValue: 0, maxValue: 100, value: sevenNightDiscountAmount, valueFormatter: (n) => `${n}% discount` }),
                    React.createElement(Spacer_1.Spacer, null),
                    React.createElement(Label_1.ParagraphLabel, { htmlFor: "twenty-eight-night-discount" }, "28 night discount"),
                    React.createElement(Spacer_1.Spacer, { spacing: "smaller" }),
                    React.createElement(merlin_input_stepper_1.InputStepper, { id: "twenty-eight-night-discount", onClick: (next28ND) => updateDiscounts(28, next28ND), minValue: 0, maxValue: 100, value: twentyEightNightDiscountAmount, valueFormatter: (n) => `${n}% discount` }),
                    React.createElement(Spacer_1.Spacer, { spacing: "large" })))));
};
exports.SmartPricingEdit = SmartPricingEdit;
//# sourceMappingURL=SmartPricingEdit.js.map